/* eslint-disable import/prefer-default-export */
import { defineStore } from 'pinia';
import { ref } from 'vue';

import filters from '@/composables/store/filters';
import useGlobalActions from '@/composables/store/globalActions';

const { formHasErrors, getErrorByField } = filters();
const { updateErrorFieldByKey } = useGlobalActions();

const formObject = ref({
  pinCode: {
    value: null,
    error: '',
    required: true,
  },
});

export const useVerificationCodeStore = defineStore({
  id: 'verificationCode',
  state: () => ({
    form: formObject,
  }),
  getters: {
    formHasErrors: (store) => formHasErrors(store),
    getErrorByField: (store) => (field) => getErrorByField(store)(field),
  },
  actions: {
    updateValue(field, val) {
      this.form[field].error = '';
      this.form[field].value = val;
    },

    updateErrorFieldByKey(field, error) {
      updateErrorFieldByKey(this.form, field, error);
    },
  },
});
